module.exports = __webpack_public_path__ + "static/img/banner-additional-service-1.5ebd478.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-additional-service-1.jpg
// module id = GcFB
// module chunks = 9